import { render, staticRenderFns } from "./TiqueteReporte.vue?vue&type=template&id=35bc3d49&scoped=true"
import script from "./TiqueteReporte.vue?vue&type=script&lang=js"
export * from "./TiqueteReporte.vue?vue&type=script&lang=js"
import style0 from "./TiqueteReporte.vue?vue&type=style&index=0&id=35bc3d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc3d49",
  null
  
)

export default component.exports